import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderBorn2You from "../../../../src/content/cissie-born-to-you/donationHeaderBornToYou";
import "../../../../src/content/cissie-born-to-you/born2you.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderBorn2You,
  React
};